import React, { FunctionComponent } from 'react';
import { auth0Client } from 'Auth';
import { useSelector } from 'react-redux';
import styles from './App.module.css';
import TopbarNavigation from '../../components/TopbarNavigation/TopbarNavigation';
import { DASHBOARD_URL } from '../../utils/environment-variables';
import Authenticator from '../Authenticator';
import CookieConsent from '../../components/CookieConsent/CookieConsent';
import { AuthenticatedUser } from '../../typings/auth';
import { selectAuthState } from '../../store/auth/auth.selectors';
import { UserRole } from 'typings/user';

interface AuthenticatorProps {
    children: React.ReactElement;
    addLayout?: boolean;
}

export interface AuthenticatedUserProps {
    userRoles: UserRole[];
    hasMultipleCompanies: boolean;
}

const WithAuthLayout: FunctionComponent<AuthenticatorProps> = (props) => {
    const { children, addLayout } = props;

    const { user } = useSelector(selectAuthState);

    const getRoles = (user: AuthenticatedUser): UserRole[] => {
        const hasRole = (roleName: string): boolean =>
            user &&
            user.roles &&
            !!user.roles.length &&
            (user.roles.includes(roleName) ||
                user.roles.includes(`Prod-${roleName}`) ||
                user.roles.includes(`Dev-${roleName}`)); // ToDo: Remove the prefixed role names

        const userRoles: UserRole[] = [];
        if (hasRole('Admin') && user.company_id === 'ALL') {
            userRoles.push('super-admin');
        }
        if (hasRole('Company-Admin') && user.company_id) {
            userRoles.push('company-admin');
        }
        if (hasRole('Recruiter-User') && user.company_id) {
            userRoles.push('recruiter-user');
        }
        if (hasRole('Candidate')) {
            userRoles.push('candidate');
        }
        return userRoles;
    };

    const userRoles: UserRole[] = getRoles(user);

    const hasMultipleCompanies =
        user &&
        (user.company_id === 'ALL' ||
            (Array.isArray(user.company_id) && user.company_id.length > 1));

    const dashboardUrl = DASHBOARD_URL || '';
    const onLogout = () => {
        // todo: move to RTK Query
        if (auth0Client) {
            auth0Client.logout({ returnTo: dashboardUrl });
        }
    };

    if (addLayout !== false) {
        require('./style.css');
        return (
            <div className={styles.layout}>
                {/* @ts-ignore*/}
                <TopbarNavigation
                    userRoles={userRoles ? userRoles : []}
                    onLogout={onLogout}
                />
                <div className={styles.content}>
                    <Authenticator>
                        {React.cloneElement(children, {
                            userRoles: userRoles ? userRoles : [],
                            hasMultipleCompanies: hasMultipleCompanies,
                        })}
                    </Authenticator>
                    <CookieConsent />
                </div>
            </div>
        );
    } else {
        return (
            <>
                <Authenticator>
                    {React.cloneElement(children, {
                        userRoles: userRoles ? userRoles : [],
                        hasMultipleCompanies: hasMultipleCompanies,
                    })}
                </Authenticator>
                <CookieConsent />
            </>
        );
    }
};

export default WithAuthLayout;
